import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

export const apiPrefixInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  let apiUrl: string = environment.apiGatewayUrl;
  if (!/^(http|https):/i.test(req.url)) {
    req = req.clone({ url: apiUrl + req.url });
  }

  return next(req);
};
